module.exports = __webpack_public_path__ + "static/media/mountain-view.270a2747.png";